module.exports = __webpack_public_path__ + "static/img/image 112@2x.539ee77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/image 112@2x.png
// module id = le/B
// module chunks = 1